<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -extra-width"
       [ngClass]="{'-is-open' : tixxSelectOverviewService.listOfModals.editLotteryDetailsModalOpened,
                  '-is-closed': !tixxSelectOverviewService.listOfModals.editLotteryDetailsModalOpened}">

  <div class="esf-main-sidebar__content">
    <h3 i18n='Customer data edit modal title@@tixxSelect.modalTitle.editEventDetails'>Edit event details</h3>
    <form [formGroup]="updateLotteryForm" (ngSubmit)="updateFormSubmit(updateLotteryForm)" id="updateLotteryForm">

      <div app-form-field-text-generic
           [control]="updateLotteryForm.get('name')"
           [placeholder]="flTranslations.i18nName"
           [label]="flTranslations.i18nName">
      </div>

      <div app-form-field-select
           [control]="updateLotteryForm.get('flexibleDate')"
           [label]="flTranslations.i18nDateTimeFlexible"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <div app-form-field-datepicker
           *ngIf="!updateLotteryForm.get('flexibleDate')?.value"
           [enableTime]="true"
           [control]="updateLotteryForm.get('date')"
           [placeholder]="flTranslations.i18nEventDate"
           [label]="flTranslations.i18nEventDate">
      </div>

      <div class="esf-form-group">
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [control]="updateLotteryForm.get('homeTeam')"
             [placeholder]="flTranslations.i18nHomeTeam"
             [label]="flTranslations.i18nHomeTeam">
        </div>
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [control]="updateLotteryForm.get('guestTeam')"
             [placeholder]="flTranslations.i18nGuestTeam"
             [label]="flTranslations.i18nGuestTeam">
        </div>
      </div>

      <div app-form-field-text-generic
           [control]="updateLotteryForm.get('competition')"
           [placeholder]="flTranslations.i18nCompetition"
           [label]="flTranslations.i18nCompetition">
      </div>
      <div app-form-field-text-generic
           [control]="updateLotteryForm.get('venue')"
           [placeholder]="flTranslations.i18nVenue"
           [label]="flTranslations.i18nVenue">
      </div>
      <div app-form-field-text-generic
           [control]="updateLotteryForm.get('type')"
           [placeholder]="flTranslations.i18nEventType"
           [label]="flTranslations.i18nEventType">
      </div>
    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -extra-width"
     [ngClass]="{'-is-open': tixxSelectOverviewService.listOfModals.editLotteryDetailsModalOpened}">
  <app-submit-row-buttons [form]="'updateLotteryForm'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="tixxSelectOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space -has-transition"
     (click)="tixxSelectOverviewService.toggleAllModal(false)"
     [ngClass]="{'-is-open': tixxSelectOverviewService.listOfModals.editLotteryDetailsModalOpened}">
  <span class="esf-hamburger__icon"></span>
</div>
